import { Platform, Dimensions } from 'react-native';

/**
 * Utilidad para detectar la plataforma actual y proporcionar información sobre ella
 */
const PlatformDetector = {
  /**
   * Verifica si la aplicación está ejecutándose en web
   * @returns {boolean} true si está en web, false en caso contrario
   */
  isWeb: () => Platform.OS === 'web',

  /**
   * Verifica si la aplicación está ejecutándose en Android
   * @returns {boolean} true si está en Android, false en caso contrario
   */
  isAndroid: () => Platform.OS === 'android',

  /**
   * Verifica si la aplicación está ejecutándose en iOS
   * @returns {boolean} true si está en iOS, false en caso contrario
   */
  isIOS: () => Platform.OS === 'ios',

  /**
   * Verifica si la aplicación está ejecutándose en un dispositivo móvil (Android o iOS)
   * @returns {boolean} true si está en móvil, false en caso contrario
   */
  isMobile: () => Platform.OS === 'android' || Platform.OS === 'ios',

  /**
   * Obtiene el nombre de la plataforma actual
   * @returns {string} 'web', 'android', 'ios' u otro según corresponda
   */
  getPlatformName: () => Platform.OS,

  /**
   * Obtiene información sobre el tamaño de la pantalla
   * @returns {Object} Objeto con ancho y alto de la pantalla
   */
  getScreenDimensions: () => {
    const { width, height } = Dimensions.get('window');
    return { width, height };
  },

  /**
   * Determina si el dispositivo está en orientación landscape
   * @returns {boolean} true si está en landscape, false si está en portrait
   */
  isLandscape: () => {
    const { width, height } = Dimensions.get('window');
    return width > height;
  },

  /**
   * Determina si el dispositivo es una tablet basado en el tamaño de la pantalla
   * (Esta es una aproximación, no es 100% precisa)
   * @returns {boolean} true si parece ser una tablet, false en caso contrario
   */
  isTablet: () => {
    const { width, height } = Dimensions.get('window');
    const screenSize = Math.sqrt(width * width + height * height);
    return screenSize >= 1000; // Umbral aproximado para tablets
  },

  /**
   * Obtiene un valor específico según la plataforma
   * @param {Object} options - Objeto con valores para diferentes plataformas
   * @param {any} options.web - Valor para web
   * @param {any} options.android - Valor para Android
   * @param {any} options.ios - Valor para iOS
   * @param {any} options.default - Valor por defecto si no se especifica para la plataforma actual
   * @returns {any} El valor correspondiente a la plataforma actual
   */
  select: (options) => {
    const platform = Platform.OS;
    if (platform in options) {
      return options[platform];
    }
    return options.default || null;
  }
};

export default PlatformDetector;
